module.exports = __webpack_public_path__ + "img/order-step.bee35251.png";